<template>
<div :class="[pageConfigLayoutStyle?.ARTICLE_PAGE_WIDE_LAYOUT ===pageLayoutStyle ? 'article-pill-button-wide-container' : 'article-pill-button-container']">
    <a :href="widgetConfig.DestinationUrl" class="pill-btn blue full-width-mobile" :target="widgetConfig.ShouldOpenInNewTab ? '_blank' : '_self'">{{ widgetConfig.ButtonText }}</a>
</div>
</template>

<script>
import {
    pageConfigLayoutStyle
} from "@/constants.js";
export default {
    name: "ArticlePillButton",
    props: {
        widgetConfig: Object,
        pageLayoutStyle: String
    },
}
</script>

<style lang="scss" scoped>
.article-pill-button-container {
    max-width: 750px;
    margin: auto;
    padding: $spacer-five $page-padding 0;
}

.article-pill-button-wide-container {
    max-width: $page-width-padded;
    margin: auto;
    padding: $spacer-five $page-padding 0;
}
.pill-btn{
    line-height: 15px;
    display:block;
    padding: 15px 0px 15px 0px;
}


</style>
